import './MainImage.css';
import { useSelector } from 'react-redux';
import { selectAllUrlParams} from '../../store/slices/urlParamsSlice';
import { getBackgroundOverlayOpacity } from '../../utils/eventStyling';

function MainImage() {
  const event = useSelector(selectAllUrlParams);
  const overlayOpacity = getBackgroundOverlayOpacity(event?.backgroundImageOpacity);

  return (
    <div className="container">
      <img
        src={event?.mainEventPhoto || require('../../assests/mainImage.jpg')}
        className="mainImage"
        alt=""
      />
      <div className="mainImageOverlay" style={{ opacity: overlayOpacity }} />
    </div>
  );
}

export default MainImage;
